export default __webpack_public_path__ + "static/media/single-project-page-05-img-26.3d7e0133.jpg";